import ReceiptNumber from './ReceiptNumber'
import RepresentativeUser from './RepresentativeUser'
import CopyReceiveDate from './CopyReceiveDate'

export const labels = {
  ReceiptNumber: 'Bizonylatszám',
  RepresentativeUser: 'Képviselő',
  CopyReceiveDate: 'Második másolat beérkezés',
};

export const allColumns = [
  {
    value: 'ReceiptNumber'
  },
  {
    value: 'RepresentativeUser'
  },
  {
    value: 'CopyCreatorUserName'
  },
  {
    value: 'CopyReceiveDate'
  },
];

export const defaultColumns = [
  {
    value: 'ReceiptNumber'
  },
  {
    value: 'RepresentativeUser'
  },
  {
    value: 'CopyReceiveDate'
  },
];

export const defaultSort = {
  prop: ReceiptNumber.propName,
  order: 'descending'
};

export default {
  ReceiptNumber,
  RepresentativeUser,
  CopyReceiveDate,
};
